<template>
  <div class="selectedCard">
    <div class="imgBox">
      <el-image :src="itemData.user&&itemData.user.avatar" fit="fill">
        <img v-if="itemData.type=='ORG'" src="../../common/images/orgIcon.png" slot="error" />
        <img v-else src="../../common/images/head.png" slot="error" />
      </el-image>
    </div>
    <div class="textBox">
      <div class="titleText">{{title}}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title:String,
    itemData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      checkedStatu: false
    }
  }
}
</script>
<style lang="scss" scoped>
.selectedCard {
  width: 100%;
  height: 100%;

  .imgBox {
    width: 100%;
    height: 32px;
    margin-right: 3px;
    border-radius: 50%;
    overflow: hidden;
    margin-bottom: 3px;
    text-align: center;

    .el-image {
      width: 32px;
      height: 32px;
      display: inline-block;
    }
  }

  .textBox {
    text-align: center;
    width: 100%;

    .titleText {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 12px;
      height: 14px;
      line-height: 14px;
    }
  }
}
</style>
